import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeAlert } from "../../redux/slices/alertSlice";
import { Modal, Button, ConfigProvider } from "antd";

/**
 * 파일명: alert.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: 공통 alert, comfirm 컴포넌트
 */
function Alert() {
  //dispatch
  const dispatch = useDispatch();

  //payload
  const payload = useSelector((state) => state.alert);

  //close
  const closeEventHandler = () => {
    payload.cancelEventHandler();
    dispatch(closeAlert());
  };

  //submit
  const submitEventHandler = () => {
    payload.submitEventHandler();
    closeEventHandler();
  };

  // Modal.config({});
  ConfigProvider.config({});

  return (
    <Modal
      className="alert-modal"
      zIndex="1111"
      title={
        <>
          {payload.img !== undefined && payload.img !== "" && payload.img}
          <p>{payload.title}</p>
        </>
      }
      centered
      maskClosable={false}
      keyboard={false}
      open={payload.display}
      onOk={() => submitEventHandler()}
      onCancel={() => closeEventHandler()}
      closable={false}
      okText="확인"
      footer={
        payload.cancleBtn ? (
          <>
            <Button type="primary" size="large" onClick={submitEventHandler}>
              확인
            </Button>
            <ConfigProvider
              theme={{
                components: {
                  Button: {
                    colorText: "#13348f",
                    colorPrimaryActive: "#13348f",
                    colorPrimaryHover: "#13348f",
                    colorBgMask: "#1f299c",
                    fontFamily: "Pretendard",
                  },
                },
              }}
            >
              <Button size="large" onClick={closeEventHandler}>
                취소
              </Button>
            </ConfigProvider>
          </>
        ) : (
          <Button type="primary" size="large" onClick={submitEventHandler}>
            확인
          </Button>
        )
      }
      cancelText="Cancel"
    >
      <section className="alert-content">{payload.content}</section>
    </Modal>
  );
}

export default Alert;
